import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/offer',
            name: 'offer',
            component: () => import(/* webpackChunkName: "static" */ '@/components/pages/PageOffer'),
            meta: {
                title: 'Условия использования'
            }
        },
        {
            path: '/registration',
            name: 'registration',
            beforeEnter() {
                window.location.href = 'https://my.telemetron.net/sign-up'
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "login" */ '@/components/pages/PageLogin'),
            meta: {
                title: 'Авторизация'
            }
        },
        {
            path: '/logout',
            name: 'logout',
            component: () => import(/* webpackChunkName: "login" */ '@/components/pages/PageLogout'),
            meta: {
                title: 'Авторизация'
            }
        },
        {
            path: '/login/forgot',
            name: 'forgot',
            component: () => import(/* webpackChunkName: "login" */ '@/components/pages/PagePasswordRecovery'),
            meta: {
                title: 'Восстановление пароля'
            }
        },
        {
            path: '/',
            name: 'home',
            component: () => import(/* webpackChunkName: "dashboard" */ '@/components/pages/PageDashboard'),
            props: route => ({ filter: route.query || {} }),
            meta: {
                requiresAuth: true,
                title: 'Главная',
                showProgressBar: false
            }
        },
        {
            path: '/stocks',
            component: () => import(/* webpackChunkName: "stocks" */ '@/components/pages/PageStocks'),
            props: route => ({ filter: route.query || {} }),
            children: [
                {
                    path: 'planograms',
                    name: 'stocks.planograms',
                    component: () => import(/* webpackChunkName: "stocks" */ '@/components/pages/PagePlanograms'),
                    props: route => ({ filter: route.query || {} }),
                    meta: {
                        requiresAuth: true,
                        title: 'Планограммы'
                    }
                },
                {
                    path: 'products',
                    name: 'stocks.products',
                    component: () => import(/* webpackChunkName: "stocks" */ '@/components/pages/PageProducts'),
                    props: route => ({ filter: route.query || {} }),
                    meta: {
                        requiresAuth: true,
                        title: 'Продукты'
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'stocks.products.new',
                            component: () => import(/* webpackChunkName: "stocks" */ '@/components/pages/PageProductForm'),
                            meta: {
                                requiresAuth: true,
                                title: 'Новый продукт'
                            }
                        },
                        {
                            path: ':id',
                            name: 'stocks.products.show',
                            component: () => import(/* webpackChunkName: "stocks" */ '@/components/pages/PageProductForm'),
                            meta: {
                                requiresAuth: true,
                                title: 'Продукт'
                            }
                        }
                    ]
                },
                {
                    path: 'recipes',
                    name: 'stocks.recipes',
                    component: () => import(/* webpackChunkName: "stocks" */ '@/components/pages/PageRecipes'),
                    props: route => ({ filter: route.query || {} }),
                    meta: {
                        requiresAuth: true,
                        title: 'Рецепты',
                        availableForFeatures: ['loading']
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'stocks.recipes.new',
                            component: () => import(/* webpackChunkName: "stocks" */ '@/components/pages/PageRecipeForm'),
                            meta: {
                                requiresAuth: true,
                                title: 'Новый рецепт',
                                availableForFeatures: ['loading']
                            }
                        },
                        {
                            path: ':id',
                            name: 'stocks.recipes.show',
                            component: () => import(/* webpackChunkName: "stocks" */ '@/components/pages/PageRecipeForm'),
                            meta: {
                                requiresAuth: true,
                                title: 'Рецепт',
                                availableForFeatures: ['loading']
                            }
                        }
                    ]
                },
                {
                    path: 'components',
                    name: 'stocks.components',
                    component: () => import(/* webpackChunkName: "stocks" */ '@/components/pages/PageComponents'),
                    props: route => ({ filter: route.query || {} }),
                    meta: {
                        requiresAuth: true,
                        title: 'Ингредиенты',
                        availableForFeatures: ['loading']
                    },
                    children: [
                        {
                            path: 'new',
                            name: 'stocks.components.new',
                            component: () => import(/* webpackChunkName: "stocks" */ '@/components/pages/PageComponentForm'),
                            meta: {
                                requiresAuth: true,
                                title: 'Новый ингредиент',
                                availableForFeatures: ['loading']
                            }
                        },
                        {
                            path: ':id',
                            name: 'stocks.components.show',
                            component: () => import(/* webpackChunkName: "stocks" */ '@/components/pages/PageComponentForm'),
                            meta: {
                                requiresAuth: true,
                                title: 'Ингредиент',
                                availableForFeatures: ['loading']
                            }
                        }
                    ]
                },
                {
                    path: '',
                    name: 'stocks',
                    redirect: 'products'
                }
            ]
        },
        {
            path: '/stocks/planograms/new',
            name: 'stocks.planograms.new',
            component: () => import(/* webpackChunkName: "stocks" */ '@/components/pages/PagePlanogram'),
            meta: {
                requiresAuth: true,
                title: 'Новая планограмма'
            }
        },
        {
            path: '/stocks/planograms/:id',
            name: 'stocks.planograms.show',
            component: () => import(/* webpackChunkName: "stocks" */ '@/components/pages/PagePlanogram'),
            meta: {
                requiresAuth: true,
                title: 'Планограмма'
            }
        },
        {
            path: '/modems',
            name: 'modems',
            component: () => import(/* webpackChunkName: "modems" */ '@/components/pages/PageModems'),
            props: route => ({ filter: route.query || {} }),
            meta: {
                requiresAuth: true,
                title: 'Модемы'
            }
        },
        {
            path: '/vms',
            name: 'vms',
            component: () => import(/* webpackChunkName: "vms" */ '@/components/pages/PageVms'),
            props: route => ({ filter: route.query || {} }),
            children: [
                {
                    path: 'new',
                    name: 'vms.new',
                    component: () => import(/* webpackChunkName: "vms" */ '@/components/pages/PageVmSettings'),
                    meta: {
                        requiresAuth: true,
                        title: 'Новый автомат'
                    }
                }
            ],
            meta: {
                requiresAuth: true,
                title: 'Автоматы',
                showProgressBar: false
            }
        },
        {
            path: '/vms/:id',
            name: 'vm',
            component: () => import(/* webpackChunkName: "vms" */ '@/components/pages/PageVm'),
            props: route => ({ id: parseInt(route.params.id), filter: route.query || {} }),
            meta: {
                requiresAuth: true,
                title: route => `Автоматы - T${route.params.id}`,
                showProgressBar: false
            },
            children: [
                {
                    path: 'loading',
                    name: 'vm.loading',
                    component: () => import(/* webpackChunkName: "vms" */ '@/components/pages/PageVmLoading'),
                    props: route => ({ filter: route.query || {} }),
                    meta: {
                        requiresAuth: true,
                        title: route => `Автоматы - T${route.params.id}`
                    }
                },
                {
                    path: 'correction',
                    name: 'vm.correction',
                    component: () => import(/* webpackChunkName: "vms" */ '@/components/pages/PageVmCorrection'),
                    meta: {
                        requiresAuth: true,
                        title: route => `Автоматы - T${route.params.id}`
                    }
                },
                {
                    path: 'settings',
                    name: 'vm.settings',
                    component: () => import(/* webpackChunkName: "vms" */ '@/components/pages/PageVmSettings'),
                    meta: {
                        requiresAuth: true,
                        title: 'Редактирование'
                    }
                }

            ]

        },
        {
            path: '/vms/:id/layout',
            name: 'vm.layout',
            component: () => import(/* webpackChunkName: "vms" */ '@/components/pages/PageVmLayout'),
            props: route => ({ id: parseInt(route.params.id) }),
            meta: {
                requiresAuth: true,
                title: route => `Автоматы - T${route.params.id}`
            }

        },

        {
            path: '/profile',
            name: 'profile',
            component: () => import(/* webpackChunkName: "profile" */ '@/components/profile/PageProfile'),
            meta: {
                requiresAuth: true,
                title: 'Профиль'
            },
            children: [
                {
                    path: 'recharge',
                    name: 'recharge',
                    component: () => import(/* webpackChunkName: "profile" */ '@/components/profile/PageRecharge'),
                    meta: {
                        title: 'Онлайн-платеж',
                        requiresAuth: true,
                        availableWhenSuspend: true
                    }
                },

                {
                    path: 'recharge-:state(success|fail)',
                    component: () => import(/* webpackChunkName: "profile" */ '@/components/profile/PageRechargeComplete'),
                    props: route => ({ state: route.params.state }),
                    meta: {
                        title: 'Онлайн-платеж',
                        requiresAuth: true,
                        availableWhenSuspend: true
                    }
                }
            ]
        },

        {
            path: '/console',
            name: 'admin',
            component: () => import(/* webpackChunkName: "admin" */ '@/components/admin/pages/PageDashboard'),
            props: route => ({ filter: route.query || {} }),
            meta: {
                title: 'Админка',
                requireAdmin: true,
                adminArea: true
            }
        },

        {
            path: '/console/transactions',
            name: 'admin.transactions',
            component: () => import(/* webpackChunkName: "admin" */ '@/components/admin/pages/PageTransactions'),
            props: route => ({ filter: route.query || {} }),
            meta: {
                title: 'Админка',
                requireAdmin: true,
                adminArea: true
            }
        },

        {
            path: '/console/billing',
            name: 'admin.billing',
            component: () => import(/* webpackChunkName: "admin" */ '@/components/admin/pages/PageBilling'),
            meta: {
                title: 'Админка - Биллинг',
                requireAdmin: true,
                adminArea: true
            }
        },

        {
            path: '/console/modems',
            name: 'admin.modems',
            component: () => import(/* webpackChunkName: "admin" */ '@/components/admin/pages/PageModems'),
            props: route => ({ filter: route.query || {} }),
            meta: {
                title: 'Модемы',
                requireAdmin: true,
                adminArea: true
            },
            children: [
                {
                    path: ':id/commands',
                    name: 'admin.modems.commands',
                    component: () => import(/* webpackChunkName: "admin" */ '@/components/admin/pages/PageModemCommands'),
                    meta: {
                        title: 'Модем',
                        requireAdmin: true,
                        adminArea: true
                    }
                }
            ]
        },

        {
            path: '/console/company/:id',
            name: 'admin.company',
            component: () => import(/* webpackChunkName: "admin" */ '@/components/admin/pages/PageCompany'),
            meta: {
                title: route => `Компания #${route.params.id}`,
                requireAdmin: true,
                adminArea: true
            }
        },

        {
            path: '/suspend',
            name: 'suspend',
            component: () => import(/* webpackChunkName: "billing" */ '@/components/pages/PageSuspend'),
            meta: {
                availableWhenSuspend: true
            }
        },

        {
            path: '*',
            redirect: '/'
        }
    ]
})
